export function estimateMonthlyPayment({
  price,
  downPct = 20,
  rate = 6.5,
  term = 30,
  taxRatePct = 1.1,
  insurancePerYear = 1200,
  hoa = 0,
}) {
  const down = (price * downPct) / 100;
  const principal = Math.max(0, price - down);
  const monthlyRate = rate / 100 / 12;
  const n = term * 12;
  const pi =
    monthlyRate === 0
      ? principal / n
      : (principal * monthlyRate) / (1 - Math.pow(1 + monthlyRate, -n));
  const tax = (price * (taxRatePct / 100)) / 12;
  const insurance = insurancePerYear / 12;
  return pi + tax + insurance + (hoa || 0);
}
